<template>
  <div>
    <cyry1 />
  </div>
</template>

<script>
// 获取接口地址
import cyry1 from '@/components/cyry'

export default {
  name: 'Cyry',
  components: {
    // sideMenu,
    // Header,
    cyry1
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
